import React, { useCallback } from "react";

import { Image, Button } from "@material-tailwind/react";

import { Box, Paper, Divider, Typography } from "@mui/material";

import { Instagram, LinkedIn, Mail, GitHub } from "@mui/icons-material";

import { PROFILE_URLS } from "../common/common.constants";

import Footer from "./footer/Footer";

import bio from "../../assets/data/info.json";

import "./verticalBar.scss";

const ProfilePicture = () => {
    return (
        <Box className="profilePictureContainer fullWidth flexContainer centerAlign px-3 py-5">
            <Image
                className="profilePicture"
                src="/assets/profile/profile.png"
                rounded={true}
                raised={true}
                alt="Profile Image"
            />
        </Box>
    );
};

const Intro = () => {
    return (
        <Box className="flexGrow flexContainer flexCol verticalBarIntro">
            <Box className="fullWidth alignSelfStart">
                <Typography
                    className="zeroMargin textCenter p-1"
                    variant="button"
                    display="block"
                >
                    FullStack Web Developer
                </Typography>
                <Divider className="divider" />
                <Box className="p-2">
                    <Typography variant="overline" display="block">
                        Hii &#128075;,
                    </Typography>
                    <Typography variant="overline" display="block">
                        I am Aniruddha Tonge
                    </Typography>

                    <Typography
                        className="zeroMargin"
                        variant="subtitle2"
                        display="block"
                    >
                        Currently,
                    </Typography>
                    <Typography
                        className="zeroMargin"
                        variant="subtitle2"
                        display="block"
                    >
                        {bio.aboutMe.designation} @{" "}
                        <a href={bio.aboutMe.company.url}>
                            {bio.aboutMe.company.title}
                        </a>
                    </Typography>
                </Box>
            </Box>
            <Box className="flexGrow flexContainer flexCol verticalBarContent p-2">
                {/* <Button
                    color="lightBlue"
                    buttonType="outline"
                    size="regular"
                    rounded={false}
                    block={false}
                    iconOnly={false}
                    ripple="dark"
                    className="downloadResumeButton"
                >
                    <a
                        href="/assets/resume/aniruddha_tonge.pdf"
                        download={"aniruddha_tonge.pdf"}
                    >
                        Download Resume
                    </a>
                </Button> */}
                <SocialMedia />
                <Box className="qoute textCenter">
                    <Typography
                        className="zeroMargin"
                        variant="subtitle1"
                        display="block"
                    >
                        " Think twice, Code Once! "
                    </Typography>
                </Box>
            </Box>
            <Divider className="divider" />
        </Box>
    );
};

const SocialMedia = () => {
    const handleSocialMediaIconClick = useCallback(
        (url) => window.open(url, "_blank", "noopener,noreferrer"),
        []
    );

    return (
        <Box className="flexContainer socialmediaIcons">
            <Instagram
                onClick={() =>
                    handleSocialMediaIconClick(PROFILE_URLS.INSTAGRAM)
                }
                className="socialmediaIcon"
            />
            <LinkedIn
                onClick={() =>
                    handleSocialMediaIconClick(PROFILE_URLS.LINKEDIN)
                }
                className="socialmediaIcon"
            />
            <a href={`mailto:${PROFILE_URLS.MAIL}`} target="_blank">
                <Mail className="socialmediaIcon" />
            </a>
            <GitHub
                onClick={() => handleSocialMediaIconClick(PROFILE_URLS.GITHUB)}
                className="socialmediaIcon"
            />
        </Box>
    );
};

const VerticalBar = () => {
    return (
        <Paper
            className="fullSpace flexContainer flexCol verticalBarContainer"
            elevation={1}
        >
            <ProfilePicture />
            <Intro className="flexGrow" />
            <Footer className="alignSelfEnd" />
        </Paper>
    );
};

export default VerticalBar;
